import { render, staticRenderFns } from "./ListadoAlumnos.vue?vue&type=template&id=148097fe&"
import script from "./ListadoAlumnos.vue?vue&type=script&lang=js&"
export * from "./ListadoAlumnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports